import { render, staticRenderFns } from "./Mostplays.vue?vue&type=template&id=8c2dd59e"
import script from "./Mostplays.vue?vue&type=script&lang=js"
export * from "./Mostplays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports